import { render, staticRenderFns } from "./OnboardingSuccess.vue?vue&type=template&id=765b5684&"
import script from "./OnboardingSuccess.vue?vue&type=script&lang=js&"
export * from "./OnboardingSuccess.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSuccess.vue?vue&type=style&index=0&id=765b5684&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports